module.exports = __webpack_public_path__ + "static/img/storage-container_256.868f066.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/storage-container_256.png
// module id = oSH5
// module chunks = 0